import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=63bb8a8b&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=ts&"
export * from "./SignUp.vue?vue&type=script&lang=ts&"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=63bb8a8b&lang=scss&scoped=true&"
import style1 from "./SignUp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb8a8b",
  null
  
)

export default component.exports